<template>
  <div class="event-slot">
    <div class="title">
      <span style="cursor: pointer;" @click="openLink(event.Link)">{{ event.Title }}</span>
    </div>
    <div class="date-time">
      <span>{{ formatDate(event.CreatedAt) }}</span>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'EventSlot',
  methods: {
    formatDate(date) {
      const dateVar = new Date(date);

      return moment(dateVar).format('DD MMMM YYYY hh:mm:ss A')
    },
    openLink (link) {
      window.open(link, '_blank')
    }
  },
  props: {
    event: {
      require: true,
      type: Object
    }
  }
}
</script>
<style lang="scss">
  .event-slot {
    display: grid;
    grid-template-columns: 3fr 1fr;
    gap: 24px;

    .title {
      span {
        font-size: 16px;
        line-height: normal;
        font-weight: 500;
        color: white;
      }
    }
    .date-time {
      background-color: #FFC108;
      border-radius: 5px;
      text-align: center;
      span {
        font-size: 12px;
        color: black;
        font-weight: 500;
      }
    }
  }
</style>